export default __webpack_public_path__ + "static/people-ca3c72351617c4ee2b3ded05c46657c4.svg";